import { render } from "./RegisterManeger.vue?vue&type=template&id=3c9aa522&scoped=true"
import script from "./RegisterManeger.vue?vue&type=script&lang=js"
export * from "./RegisterManeger.vue?vue&type=script&lang=js"

import "./RegisterManeger.vue?vue&type=style&index=0&id=3c9aa522&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\ilustranext\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c9aa522"]])

export default __exports__